import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { catchError, switchMap, share, withLatestFrom, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { SuitabilityBypassAgreementActions } from './suitability-bypass-agreement.action';
import { StocksApiService } from '@toro/common/shared/services/stocks/stocks-api.service';

@Injectable()
export class SuitabilityBypassAgreementEffects {
    public suitabilityBypass$ = this.store.select(s => s['suitabilityBypassAgreement']);

    @Effect()
    public getSuitabilityBypassAgreement: Observable<any> = this.actions$
        .pipe(
            ofType(SuitabilityBypassAgreementActions.getSuitabilityBypassAgreement),
            withLatestFrom(this.store.select((authStore) => authStore.authentication)),
            switchMap(([_, auth]) => {
                const apiUrl = `user-acceptance/unsuitable-profile-user-awareness`
                return this.stocksApiService.get(apiUrl)
                    .pipe(
                        map((suitabilityBypassAgreement: any) => {
                            if (suitabilityBypassAgreement) {
                                return {
                                    type: SuitabilityBypassAgreementActions.getSuitabilityBypassAgreementSuccess,
                                    payload: suitabilityBypassAgreement
                                }
                            }
                        })
                    );
            }),
            catchError((error) => of ({type: SuitabilityBypassAgreementActions.getSuitabilityBypassAgreementError, payload: error})),
            share());


            @Effect()
            public updateSuitabilityBypassAgreement: Observable<any> = this.actions$
                .pipe(
                    ofType(SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreement),
                    withLatestFrom(this.store.select((authStore) => authStore.authentication)),
                    switchMap(([action, auth]) => {
                        const apiUrl = `user-acceptance/unsuitable-profile-user-awareness`
                        return this.stocksApiService.put(apiUrl, action.payload.data)
                            .pipe(
                                map((suitabilityBypassAgreement: any) => {
                                    if (suitabilityBypassAgreement) {
                                        return {
                                            type: SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreementSuccess,
                                            payload: suitabilityBypassAgreement
                                        }
                                    }
                                })
                            );
                    }),
                    catchError((error) => of ({type: SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreementError, payload: error})),
                    share());
        
        
                  

        constructor(
            private actions$: Actions<SuitabilityBypassAgreementActions>,
            private store: Store<AppState>,
            private stocksApiService: StocksApiService
        ) { }
}